import { render } from "./MentoringDetailsDialog.vue?vue&type=template&id=6e274b95"
import script from "./MentoringDetailsDialog.vue?vue&type=script&lang=js"
export * from "./MentoringDetailsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__